import { BulkResizeState } from "../../../types";

interface Payload {
    payload: {
        imageId: string;
    };
}

export const reset = (state: BulkResizeState, { payload }: Payload) => {
    const image = state.images.find((image) => image.id === payload.imageId);
    if (!image) return;

    image.crop.ratio = "freeform";
    image.crop.customRatioValues = { x: 1, y: 1 };
};
